var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidenav-toggle",class:{ 'is-active': _vm.visible },on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":_vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }